export const PROJECT_NAME = "PaperLens";
export const LOGO_PATH = "/assets/images/logo.png";
export const HERO_BG_PATH = "/assets/images/bg.webp";
